module.exports = __webpack_public_path__ + "static/media/EngraversGothicBold.790335b0.otf";